export enum OfferType {
  OffOffer = "OFF_AMOUNT",
  FreeGift = "FREE_GIFT",
}
